<template>
  <transition name="fade">
    <div style="position: fixed; width: 100%" v-if="this.getErrorModal">
  <div class="behindModal"></div>
      <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                        <div class="col-xs-3 modalIcon warningImage"></div>
                        <div class="col-xs-9">
                                <h5 class="modal-title warningTheme" id="exampleModalLabel">Uyarı</h5>
                        </div>
                </div>
                <div class="modal-body">
                    <p class="modalTextArea">Bir hata oluştu.</p>
                </div>
                <div class="modal-footer">
                <button class="warningTheme unselectable" @click="this.closeModal">Kapat</button>
                </div>
            </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    data() {
        return{}
    },
    computed: {
      getErrorModal() {
        if(this.$store.state.errorModal === true) {
          return true;
        } else {
          return false;
        }
      }
    },
    methods: {
      ...mapActions[
        'errorModal'
      ],
      ...mapGetters[
        'errorModal'
      ],
      closeModal() {
        this.$store.dispatch('errorModal', false);
      }
    }
}
</script>

<style>
</style>
